import PropTypes from 'prop-types'
import React from 'react'
import Input from 'components/Input'
import ListRow from 'components/ListRow'
import { USER_MODEL_KEY, USER_MODEL_PLACEHOLDER } from 'models/daos/user/constants'

class UserRowFullName extends React.Component {
  static defaultProps = {
    isEditing: null
  }

  static propTypes = {
    value: PropTypes.string.isRequired,
    isEditing: PropTypes.bool,
    /**
     * Color of the input.
     * e.g. `error` => `red`
     * @type {string}
     */
    colorType: PropTypes.oneOf(
      Object.values(Input.COLOR_TYPE)
    ),
    onChange: PropTypes.func
  }

  handleChange (event, key, value) {
    this.props.onChange(value)
  }

  renderBody () {
    if (!this.props.isEditing) {
      return this.renderFullName()
    }
    return this.renderEditFullName()
  }

  renderEditFullName () {
    const props = {
      value: this.props.value,
      name: USER_MODEL_KEY.FULL_NAME,
      placeholder: USER_MODEL_PLACEHOLDER[USER_MODEL_KEY.FULL_NAME],
      colorType: this.props.colorType,
      isBorderless: true,
      hasNoPadding: true,
      onChange: this.handleChange.bind(this)
    }
    return <Input {...props} />
  }

  renderFullName () {
    return (
      <ListRow.Text>
        {this.props.value}
      </ListRow.Text>
    )
  }

  render () {
    return (
      <div>
        {this.renderBody()}
      </div>
    )
  }
}

export default UserRowFullName
